import React from 'react';
import ServicePage from '../../components/PublicSite/ServicePage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Fuel Delivery in the UAE — Petrol & Diesel Brought to You | Bas Recovery',
    description: 'Out of fuel? Petrol or diesel delivered to your vehicle from AED 18, plus injection, pump and pressure work. Call 050 505 2213, 24/7.',
    component: (
      <HeadLessLayout>
        <ServicePage service="fuel" />
      </HeadLessLayout>
    ),
  };
}

export default action;
